// Click tracking for the HOGAPAGE Immobilien area, declared in the markup.
//
// One delegated listener on the document rather than a listener per element:
// the tracked elements sit in bands across three templates, several of them
// inside `{% if %}` blocks. Delegation means the markup is the only place a new
// tracked element has to be touched.
//
//     <a href="…" data-re-track="realEstateCtaClick" data-re-track-cta="pachtpro">
//
// `data-re-track` is the event name; every further `data-re-track-*` becomes a
// dimension beside it, so a band can report what it is without this file
// knowing the band exists.
//
// The push itself goes through the global `push_datalayer()` from
// `buhl_style/static/js/components/base.js`, which feeds GTM and Matomo from
// one dict. That file is a classic <script> in <head> and this is a deferred
// module, so it has always run by the time anything here fires — the guard in
// `push()` is for the cookie banner's vendor blocking, not for load order.

const TRACK_ATTRIBUTE = "data-re-track";
const TRACK_SELECTOR = `[${TRACK_ATTRIBUTE}]`;

// Strips the `reTrack` dataset prefix and returns the rest as snake_case, the
// spelling every dimension in this project's dataLayer already uses:
// `data-re-track-offer-uid` -> `offer_uid`.
function dimensionName(key) {
    return key
        .slice("reTrack".length)
        .replace(/^./, (character) => character.toLowerCase())
        .replace(/[A-Z]/g, (character) => `_${character.toLowerCase()}`);
}

function push(event, dimensions) {
    // Absent when the consent banner has not released the vendor. Dropping the
    // event is the right answer there — queueing it would push it the moment
    // something else loaded base.js, which is consent we do not have.
    if (typeof window.push_datalayer !== "function") {
        return;
    }
    window.push_datalayer({ event, ...dimensions });
}

function trackElement(element) {
    const dimensions = {};
    Object.entries(element.dataset).forEach(([key, value]) => {
        if (key.startsWith("reTrack") && key !== "reTrack") {
            dimensions[dimensionName(key)] = value;
        }
    });
    push(element.dataset.reTrack, dimensions);
}

function onClick(event) {
    // `closest`, not `event.target`: every one of these is a link or a button
    // with markup inside it, so the click lands on a <span> or an <svg> as
    // often as on the element carrying the attribute.
    const element = event.target.closest(TRACK_SELECTOR);
    if (!element) {
        return;
    }
    trackElement(element);
}

// Capture phase. The PDF link and the CTAs are real navigations, and a listener
// in the bubble phase races the unload of the page it is reporting from.
document.addEventListener("click", onClick, true);

// Exported so the gallery can report its lightbox from the point it actually
// opens, rather than from a tile click that may be a plain navigation.
export { push };
